<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <div class="d-flex justify-start" v-if="!show_payment_form">
              <p>
                <v-btn color="primary-dark" @click="$router.go(-1)" block class="sm-fullwidth mt-2" variant="default"
                  size="small"> <v-icon icon="mdi-arrow-left-bold" class="mr-1"></v-icon> Retour </v-btn>
              </p>
            </div>
            <v-divider></v-divider>
            <h4 class="font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
                size="xs-small"></v-icon> Mon compte Sportips</h4>
            <div v-if="mainStore.authUser.isLogged">Connecté en tant que {{ mainStore.authUser.userMail }}</div>
            <v-row v-else>
              <v-col md="6" cols="12">
                <LoginForm></LoginForm>
              </v-col>
            </v-row>

            <v-divider></v-divider>
            <h4 class="font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
                size="xs-small"></v-icon> Récapitulatif de ma commande</h4>
            <v-row>
              <v-col cols="12" md="5" v-if="!show_payment_form">
                <div class="d-flex flex-column align-start justify-stretch rounded bg-dark pa-4 mt-2">
                  <div class="d-flex justify-space-between w-100">
                    <div>Nombre d'articles</div>
                    <div>
                      {{ amendBookingStore.cart.nb_articles }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between w-100">
                    <div>Sous Total</div>
                    <div v-if="amendBookingStore.cart.prix > 0">{{ amendBookingStore.cart.prix }}€
                    </div>
                  </div>
                  <div class="d-flex justify-space-between w-100">
                    <div>Frais de gestion</div>
                    <div>{{ amendBookingStore.cart.taxe }}€</div>
                  </div>
                  <div class="d-flex justify-space-between w-100">
                    <div>Total à payer</div>
                    <div>{{ amendBookingStore.cart.prix_total }}€</div>
                  </div>

                  <div class="w-100" v-if="mainStore.authUser.isLogged">
                    <BeforeAccessCheckout @handle_free_checkout="handle_free_checkout()"
                      @access_checkout="access_checkout()"></BeforeAccessCheckout>
                  </div>
                  <div class="mt-4" v-else>
                    <v-alert>Vous devez vous connecter à votre compte Sportips via le formulaire ci-dessus afin
                      d'accèder au paiement et valider votre inscription.</v-alert>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="5" v-else>
                <AfterAccessCheckout></AfterAccessCheckout>
              </v-col>
            </v-row>
            <div class="d-flex justify-center mt-3"></div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import { useAmendBookingStore } from "@/stores/amendBookingStore";
import LoginForm from "@/components/Authentification/LoginForm.vue";
import BeforeAccessCheckout from "@/components/FicheCoureur/AddOptions/Before_Access_Checkout.vue";
import AfterAccessCheckout from "@/components/FicheCoureur/AddOptions/After_Access_Checkout.vue";
export default {
  components: { LoginForm, BeforeAccessCheckout, AfterAccessCheckout },
  data() {
    return {
      show_payment_form: false,
    };
  },
  computed: {
    ...mapStores(useMainStore, useAmendBookingStore, useBookingStore),
  },
  methods: {
    async handle_free_checkout() {
      const post_request = await this.amendBookingStore.post_free_checkout();
      if (post_request) {
        this.$router.push({ name: "CheckoutSuccess" });
      }
    },
    access_checkout() {
      this.show_payment_form = true;
    },
  },
  async created() {
    if (!this.mainStore.authUser.isLogged) {
      this.$router.push({ name: "FicheCoureur" });
    }
    if (!this.amendBookingStore.isLoaded) {
      this.$router.push({ name: "FicheCoureur" });
    }
  },
};
</script>

<style lang="scss" scoped>
.logo_paiement {
  width: 150px;
  max-width: 100%;
  height: auto;
}
</style>